<div class="road-boq-form p-6 max-w-4xl mx-auto">
  <div class="flex items-center justify-between mb-6">
    <h2 class="text-xl font-semibold">{{ recordId ? 'Road BoQ' : 'New Road BoQ' }}</h2>
    <button mat-stroked-button type="button" (click)="backToList()">Back to list</button>
  </div>

  <p *ngIf="loading" class="text-slate-500">Loading…</p>

  <form [formGroup]="form" (ngSubmit)="save()" *ngIf="!loading" class="grid grid-cols-12 gap-4">
    <div class="col-span-6">
      <mat-label>BoQ code</mat-label>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="boq_code" />
      </mat-form-field>
    </div>
    <div class="col-span-6">
      <mat-label>BoQ name</mat-label>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput formControlName="boq_name" />
      </mat-form-field>
    </div>
    <div class="col-span-4">
      <mat-label>Road length (km)</mat-label>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput type="number" step="0.001" formControlName="road_length_km" />
      </mat-form-field>
    </div>

    <div class="col-span-12 p-4 border border-slate-200 rounded-lg bg-slate-50">
      <div class="flex items-center justify-between mb-3">
        <h3 class="text-sm font-semibold">LRS corridor</h3>
        <div class="flex gap-2">
          <button mat-stroked-button type="button" color="primary" (click)="generateFromGis()" [disabled]="!form.value.project_id">
            Generate from GIS
          </button>
          <button mat-stroked-button type="button" (click)="openOnMap()">Open on map</button>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-6">
          <mat-label>Route</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select formControlName="lrs_route_id">
              <mat-option [value]="null">None</mat-option>
              <mat-option *ngFor="let route of lrsRoutes" [value]="route.id">
                {{ route.route_code }} — {{ route.route_name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-span-3">
          <mat-label>From km</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput type="number" step="0.001" formControlName="lrs_from_km" />
          </mat-form-field>
        </div>
        <div class="col-span-3">
          <mat-label>To km</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput type="number" step="0.001" formControlName="lrs_to_km" />
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label>Chainage label</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="lrs_chainage" />
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="col-span-12 flex gap-3 mt-2">
      <button mat-raised-button color="primary" type="submit" [disabled]="saving">
        {{ saving ? 'Saving…' : (recordId ? 'Update' : 'Create') }}
      </button>
    </div>
  </form>
</div>
